/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';

import classes from './Icon.module.scss';

const IconButton = props => {
    const { children, className, buttonColors, ...otherProps } = props;
    return (
        <button type="button" className={clsx(classes.wrapper, className)} {...otherProps}>
            {children}
        </button>
    );
}

export default IconButton;
